import { render, staticRenderFns } from "./question-configure.vue?vue&type=template&id=ebe35672&scoped=true&"
import script from "./question-configure.vue?vue&type=script&lang=ts&"
export * from "./question-configure.vue?vue&type=script&lang=ts&"
import style0 from "./question-configure.vue?vue&type=style&index=0&id=ebe35672&prod&lang=less&scoped=true&"
import style1 from "./question-configure.vue?vue&type=style&index=1&id=ebe35672&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe35672",
  null
  
)

export default component.exports